import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { RDPropsetContainer } from '../Container/PropContainer.js';
import { icons } from '../../../Icons.js';

import styles from './Image.css?raw';
const svgXml = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" >
  <path d="M5.9902344 4.9902344 A 1.0001 1.0001 0 0 0 5.2929688 6.7070312L19.919922 21.333984C16.943943 23.520175 15 27.033628 15 31L15 69C15 75.615466 20.384534 81 27 81L73 81C74.91318 81 76.717402 80.538494 78.324219 79.738281L93.292969 94.707031 A 1.0001 1.0001 0 1 0 94.707031 93.292969L80.080078 78.666016C83.056057 76.479825 85 72.966372 85 69L85 31C85 24.384534 79.615466 19 73 19L27 19C25.08682 19 23.282598 19.461506 21.675781 20.261719L6.7070312 5.2929688 A 1.0001 1.0001 0 0 0 5.9902344 4.9902344 z M 27 21L73 21C78.534534 21 83 25.465466 83 31L83 69C83 72.429954 81.281865 75.445767 78.660156 77.246094L76.480469 75.066406C78.580593 73.856817 80 71.592973 80 69L80 64.595703 A 0.50005 0.50005 0 0 0 80 64.425781L80 53.5 A 0.50005 0.50005 0 1 0 79 53.5L79 63.292969L66.558594 50.851562C65.991762 50.284731 65.243958 50 64.5 50C63.756042 50 63.008238 50.284731 62.441406 50.851562L57.353516 55.939453L26.443359 25.029297C26.626644 25.012522 26.812255 25 27 25L68.5 25 A 0.50005 0.50005 0 1 0 68.5 24L27 24C26.507586 24 26.0284 24.053231 25.564453 24.150391L23.173828 21.759766C24.352353 21.272805 25.64282 21 27 21 z M 21.339844 22.753906L23.519531 24.933594C21.419407 26.143183 20 28.407027 20 31L20 56.429688 A 0.50005 0.50005 0 0 0 20 56.591797L20 69C20 72.860195 23.139805 76 27 76L67.429688 76 A 0.50005 0.50005 0 0 0 67.591797 76L73 76C73.492414 76 73.9716 75.946769 74.435547 75.849609L76.826172 78.240234C75.647647 78.727195 74.35718 79 73 79L27 79C21.465466 79 17 74.534534 17 69L17 31C17 27.570046 18.718135 24.554233 21.339844 22.753906 z M 24.251953 25.666016L55.939453 57.353516L53 60.292969L36.558594 43.851562C35.991762 43.284731 35.243958 43 34.5 43C33.756042 43 33.008238 43.284731 32.441406 43.851562L21 55.292969L21 31C21 28.671913 22.31955 26.661261 24.251953 25.666016 z M 66.5 32C64.708334 32 63.301922 32.689878 62.376953 33.730469C61.451984 34.77106 61 36.138889 61 37.5C61 38.861111 61.451984 40.22894 62.376953 41.269531C63.301922 42.310122 64.708334 43 66.5 43C69.531645 43 72 40.531643 72 37.5C72 34.468357 69.531645 32 66.5 32 z M 66.5 33C68.991206 33 71 35.008796 71 37.5C71 39.991204 68.991206 42 66.5 42C64.958334 42 63.864743 41.439878 63.123047 40.605469C62.38135 39.77106 62 38.638889 62 37.5C62 36.361111 62.38135 35.22894 63.123047 34.394531C63.864743 33.560122 64.958334 33 66.5 33 z M 79.492188 40.992188 A 0.50005 0.50005 0 0 0 79 41.5L79 43.5 A 0.50005 0.50005 0 1 0 80 43.5L80 41.5 A 0.50005 0.50005 0 0 0 79.492188 40.992188 z M 34.5 44C34.990042 44 35.476395 44.183426 35.851562 44.558594L52.576172 61.283203 A 0.50005 0.50005 0 0 0 52.720703 61.425781L66.292969 75L27 75C23.680195 75 21 72.319805 21 69L21 56.707031L33.148438 44.558594C33.523605 44.183426 34.009958 44 34.5 44 z M 79.492188 45.992188 A 0.50005 0.50005 0 0 0 79 46.5L79 50.5 A 0.50005 0.50005 0 1 0 80 50.5L80 46.5 A 0.50005 0.50005 0 0 0 79.492188 45.992188 z M 64.5 51C64.990042 51 65.476395 51.183426 65.851562 51.558594L79 64.707031L79 69C79 71.328087 77.68045 73.338739 75.748047 74.333984L58.060547 56.646484L63.148438 51.558594C63.523605 51.183426 64.009958 51 64.5 51 z M 56.646484 58.060547L73.556641 74.970703C73.373356 74.987478 73.187745 75 73 75L67.707031 75L53.707031 61L56.646484 58.060547 z" fill="#696969" />
</svg>`;

// 1. Encode the XML string for use in a URI
const encodedSvg = encodeURIComponent(svgXml);

// 2. Prepend the Data URL header
const noImageSrc = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;
export class propImage extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    src: { type: Object },
    alt: { type: String },
    errorSrc: { type: String },
    currentIndex: { type: Number },
    onCurrentIndexChange: { type: Function },
    onPreview: { type: Function },
    onChange: { type: Function },
    onDelete: { type: Function },
    onError: { type: Function },
    loading: { type: Boolean, reflect: true },
    showPreview: { type: Boolean, reflect: true },
    showChange: { type: Boolean, reflect: true },
    showDelete: { type: Boolean, reflect: true },
  };
  constructor() {
    super();
    /**
     * @type {string | [{path:string, alt?:string}] | {path:string, alt?:string}}
     */
    this.src = '';
    this.alt = '';
    this.errorSrc = noImageSrc;
    this.currentIndex = 0;
    this.onPreview = null;
    this.onChange = null;
    this.onCurrentIndexChange = null;
    this.onError = null;
    this.onDelete = null;
    this.loading = true;
    this.showPreview = true;
    this.showChange = true;
    this.showDelete = true;
  }
  _getSrcType() {
    if (Array.isArray(this.src)) {
      return 'array';
    }
    if (typeof this.src === 'object' && this.src !== null && 'path' in this.src) {
      return 'object';
    }
    return 'string';
  }

  _getCurrentImageData() {
    const type = this._getSrcType();
    if (type === 'array') {
      const item = this.src[this.currentIndex] || this.src[0];
      if (typeof item === 'string') {
        return { path: item, alt: this.alt || '' };
      }
      return { path: item.path, alt: item.alt || this.alt || '' };
    }
    if (type === 'object') {
      return { path: this.src.path, alt: this.src.alt || this.alt || '' };
    }
    return { path: this.src, alt: this.alt || '' };
  }
  // willUpdate(changedProperties) {
  //   if (changedProperties.has('src') || changedProperties.has('currentIndex')) {
  //     this.loading = true;
  //     this._error = false;
  //   }
  // }
  _handleImageError(e) {
    if (this.errorSrc) {
      if (this.errorSrc !== e.target.src) {
        e.target.src = this.errorSrc;
        if (this.onError && typeof this.onError === 'function') {
          this.onError.bind(this)(this.currentIndex);
        }
        this.loading = false;
      }
    }
  }
  _handleImageSuccess(e) {
    this.loading = false;
  }

  _handlePreview() {
    const imageData = this._getCurrentImageData();
    if (this.onPreview && typeof this.onPreview === 'function') {
      this.onPreview.bind(this)(imageData, this.currentIndex);
    }
    this.dispatchEvent(
      new CustomEvent('preview', {
        detail: { image: imageData, index: this.currentIndex },
      })
    );
  }

  _handleChange(item) {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)(item, this.currentIndex);
    }
    this.dispatchEvent(
      new CustomEvent('change-image', {
        detail: { index: this.currentIndex },
      })
    );
  }

  _handleDelete() {
    const imageData = this._getCurrentImageData();
    if (this.onDelete && typeof this.onDelete === 'function') {
      this.onDelete.bind(this)(imageData, this.currentIndex);
    }
    this.dispatchEvent(
      new CustomEvent('delete-image', {
        detail: { image: imageData, index: this.currentIndex },
      })
    );
  }

  _navigateCarousel(direction) {
    if (!Array.isArray(this.src)) return;
    let preIndex = this.currentIndex;
    if (direction === 'prev') {
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.src.length - 1;
    } else {
      this.currentIndex = this.currentIndex < this.src.length - 1 ? this.currentIndex + 1 : 0;
    }
    let currIndex = this.currentIndex;
    if (this.onCurrentIndexChange && typeof this.onCurrentIndexChange === 'function') {
      this.onCurrentIndexChange.bind(this)(currIndex, preIndex);
    }
    this.loading = true;
    this.requestUpdate();
  }

  _renderCarousel() {
    const imageData = this._getCurrentImageData();
    const totalImages = this.src.length;

    return html`
      <div class="prop-image-carousel ${this.loading ? 'loading' : ''}">
        <div class="carousel-image-wrapper">
          <img src="${imageData.path}" alt="${imageData.alt}" @error="${this._handleImageError}" @load="${this._handleImageSuccess}" />
          <div class="carousel-overlay">
            <button class="carousel-btn carousel-prev" @click="${() => this._navigateCarousel('prev')}">‹</button>
            <button class="carousel-btn carousel-next" @click="${() => this._navigateCarousel('next')}">›</button>
            <div class="carousel-indicators">
              ${this.src.map(
                (_, index) => html`
                  <span
                    class="indicator ${index === this.currentIndex ? 'active' : ''}"
                    @click="${() => {
                      if (index === this.currentIndex) return;
                      const preIndex = this.currentIndex;
                      const currIndex = index;
                      if (this.onCurrentIndexChange && typeof this.onCurrentIndexChange === 'function') {
                        this.onCurrentIndexChange.bind(this)(currIndex, preIndex);
                      }
                      this.currentIndex = index;
                      this.loading = true;
                      this.requestUpdate();
                    }}"
                  ></span>
                `
              )}
            </div>
            <div class="carousel-actions">
              ${this.showPreview
                ? html`
                    <button class="icon-indicator preview-indicator" @click="${this._handlePreview}" title="Preview">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </button>
                  `
                : ''}
              ${this.showChange ? html` <button class="icon-indicator change-indicator" @click="${() => this._handleChange(imageData)}" title="Change">${unsafeHTML(icons.pen)}</button> ` : ''}
              ${this.showDelete
                ? html`
                    <button class="icon-indicator delete-indicator" @click="${this._handleDelete}" title="Delete">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                  `
                : ''}
            </div>
          </div>
          <div class="carousel-counter">${this.currentIndex + 1} / ${totalImages}</div>
        </div>
      </div>
    `;
  }

  _renderImage() {
    const imageData = this._getCurrentImageData();

    return html`
      <div class="prop-image-container  ${this.loading ? 'loading' : ''}">
        <div class="image-wrapper ">
          <img src="${imageData.path}" alt="${imageData.alt}" @error="${this._handleImageError}" @load="${this._handleImageSuccess}" class="single-image" />
          <div class="image-overlay">
            ${this.showPreview
              ? html`
                  <button class="icon-indicator preview-indicator" @click="${this._handlePreview}" title="Preview">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  </button>
                `
              : ''}
            ${this.showChange ? html` <button class="icon-indicator change-indicator" @click="${() => this._handleChange(imageData)}" title="Change">${unsafeHTML(icons.pen)}</button> ` : ''}
            ${this.showDelete
              ? html`
                  <button class="icon-indicator delete-indicator" @click="${this._handleDelete}" title="Delete">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>
                `
              : ''}
          </div>
        </div>
      </div>
    `;
  }

  renderBody() {
    const type = this._getSrcType();
    if (type === 'array') {
      return this._renderCarousel();
    }
    return this._renderImage();
  }
}
if (!customElements.get('rd-prop-image')) {
  customElements.define('rd-prop-image', propImage);
}
